<div class="block search-bar">
  <div class="search-bar__field-search">
    <scc-dsm3-search-control
      [formGroup]="viewModel.formGroup"
      formName="search"
      type="text"
      placeholder="CPE ou ID ou Utilizador"
      [applyClearOnSearch]="true"
      (onApplySearch)="onValueChange()"
      (onEnter)="onValueChange()"
      (onFocus)="onFocusSearch()"
      (onClearSearch)="onValueChange()"
    >
    </scc-dsm3-search-control>
  </div>

  <div class="search-bar__field-date">
    <scc-dsm3-date-picker-control-alt
      #date
      type="RANGE"
      placeholder="Data"
      [clearOnNewClick]="true"
      [closeOnClear]="true"
      formatDateOutput="yyyy-MM-dd"
      minDate="2012"
      maxDate="{{ currentYear + 1 }}"
      [control]="getInputFormDateControl"
      [canRangeSelectSameDate]="true"
      (onOpen)="onOpenDatepicker()"
      (onSelectedDate)="inputDateValueChange($event)"
      (onClear)="onValueChange()"
    ></scc-dsm3-date-picker-control-alt>
  </div>

  <div class="search-bar__field-state">
    <scc-dsm3-dropdown-control
      #states
      [formGroup]="viewModel?.formGroup"
      formName="states"
      [options$]="viewModel?.$states"
      placeholder="Estado"
      (onOpen)="onOpenDropdownStates()"
    >
    </scc-dsm3-dropdown-control>
  </div>

  <div class="search-bar__field-category">
    <scc-dsm3-radio-dropdown-control
      [formGroup]="viewModel?.formGroup"
      formName="category"
      [options$]="viewModel?.$categories"
      placeholder="Categoria"
      (onOpen)="onOpenDropdownRadioCategories()"
    >
    </scc-dsm3-radio-dropdown-control>
  </div>

  <div class="search-bar__field-area">
    <scc-dsm3-dropdown-control
      #areas
      [formGroup]="viewModel?.formGroup"
      formName="areas"
      [options$]="viewModel?.$areas"
      placeholder="Área"
      (onOpen)="onOpenDropdownArea()"
    >
    </scc-dsm3-dropdown-control>
  </div>
</div>
